import React from 'react';
import ReactDOM from 'react-dom/client';
import HomePage from './HomePage';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import SimposioPage from "./SimposioPage";
import NovedadesPage from "./NovedadesPage";
import PatrocinadoresPage from "./PatrocinadoresPage";
import AlojamientoPage from "./AlojamientosPage";
import CookiesPage from "./CookiesPage";
import LegalPage from "./LegalPage";
import PoliticaPrivacidadPage from "./PoliticaPrivacidadPage";
import ContactoPage from "./ContactoPage";

const router = createBrowserRouter([
    {path: "/", element: <HomePage/>},
    // {path: "/simposio/programas", element: <SimposioPage idx={0}/> },
    {path: "/simposio/fechas", element: <SimposioPage idx={0}/>},
    {path: "/simposio/areas", element: <SimposioPage idx={1}/>},
    {path: "/simposio/comites", element: <SimposioPage idx={2}/>},
    {path: "/simposio/sede", element: <SimposioPage idx={3}/>},
    {path: "/simposio/comunicaciones", element: <SimposioPage idx={4}/>},
    {path: "/simposio/inscripciones", element: <SimposioPage idx={5}/>},
    {path: "/simposio/premios", element: <SimposioPage idx={6}/>},
    {path: "/novedades", element: <NovedadesPage/>},
    {path: "/patrocinadores", element: <PatrocinadoresPage/>},
    {path: "/alojamiento", element: <AlojamientoPage/>},
    {path: "/cookies", element: <CookiesPage/>},
    {path: "/aviso-legal", element: <LegalPage/>},
    {path: "/politica-privacidad", element: <PoliticaPrivacidadPage/>},
    {path: "/contacto", element: <ContactoPage/>},

]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode>
    <RouterProvider router={router}/>
</React.StrictMode>);
